// squareChart component

export default function () {

    let width = 130,
        height = 130,
        squareWidth = 80,
        axisHeight = 100,
        display = true, // stop render if no null
        margin = {top:5, right:5, bottom:5, left:5},
        fColour = '#ff5763',
        bColour = '#ebebeb';

    let format = d3.format("0,000");

    let dataValue, dataMin, dataMax;

    let dispatch = d3.dispatch('customHover');

    function exports(_selection) {
        _selection.each(function() {

            let chartScale = d3.scale.linear()
                .domain([dataMin, dataMax])
                .range([0, squareWidth])
                .nice();

            let axisScale = d3.scale.linear()
                .domain([dataMin, dataMax])
                .range([squareWidth, 0])
                .nice();

            let svg = d3.select(this).selectAll('svg')
                    .data([0]);

            svg.enter().append('svg')
                .attr({
                    width: (width + margin.left + margin.right),
                    height: (height + margin.top + margin.bottom)
                });

            //START AXIS
            let axisContainer = svg.selectAll('.sqaure-axis')
                    .data([0]);

            axisContainer.enter().append('g')
                .attr('class', 'sqaure-axis')
                .attr('transform', 'translate(' + squareWidth + ', 0)');

            let axis = fc.svg.axis()
                .scale(axisScale)
                .orient('right')
                .ticks(2)
                .outerTickSize(4)
                .innerTickSize(8)
                .tickPadding(2);
                // .decorate(function(s) {
                //     s.enter()
                //         .select('text')
                //         .style('fill', function(d) {
                //             return d >= 100 ? 'red' : 'black';
                //         });
                // });

            axisContainer.call(axis);
            //END

            // add the background rect
            let squareBg = svg.selectAll('.thed3-square-bg')
                .data([0]);

            squareBg.enter().append('rect')
                .attr({
                   class: 'thed3-square-bg',
                   x: 0,
                   width: squareWidth,
                   y: 0,
                   height: squareWidth
                })
                .style({
                    fill: bColour,
                    stroke: 'none'
                });

            // add the data rect
            let square = svg.selectAll('.thed3-square')
                .data([0]);

            square.enter().append('rect').attr('class', 'thed3-square');

            square.style({
                        fill: fColour,
                        stroke: 'none'
                    });

            // don't display set to false (null values)
            if (display) {
                square.transition()
                    .attr({
                       class: 'thed3-square',
                       x: 0,
                       width: squareWidth,
                       y: squareWidth - chartScale(dataValue),
                       height: chartScale(dataValue)
                    });
                square
                    .on('mouseover', dispatch.customHover);
            } else { // have no zero height
                square.transition()
                    .attr({
                       class: 'thed3-square',
                       x: 0,
                       width: squareWidth,
                       y: squareWidth,
                       height: 0
                    });
            }

            // add text data
            let text = svg.selectAll('.thed3-square-txt')
                .data([0]);

            text.enter().append('text').attr('class', 'thed3-square-txt');

            text.attr({
                'text-anchor': 'middle',
                y: squareWidth - 20,
                x: squareWidth/2,
            })
            .text(function() {
                if (dataValue === 0 || _.isNull(dataValue)) {
                    return 'No data';
                } else {
                    return format(dataValue);
                }
            });
        
        });

    }

   exports.width = function(value) {
      if (!arguments.length) return width;
      width = value;
      return this;
   };
   exports.height = function(value) {
      if (!arguments.length) return height;
      height = value;
      return this;
   };
   exports.margin = function(value) {
      if (!arguments.length) return margin;
      margin = value;
      return this;
   };
   exports.dataValue = function(value) {
      if (!arguments.length) return dataValue;
      dataValue = value;
      return this;
   };
   exports.dataMax = function(value) {
      if (!arguments.length) return dataMax;
      dataMax = value;
      return this;
   };
   exports.dataMin = function(value) {
      if (!arguments.length) return dataMin;
      dataMin = value;
      return this;
   };
   exports.fColour = function(value) {
      if (!arguments.length) return fColour;
      fColour = value;
      return this;
   };
   exports.bColour = function(value) {
      if (!arguments.length) return bColour;
      bColour = value;
      return this;
   };
   exports.display = function(value) {
      if (!arguments.length) return display;
      display = value;
      return this;
   };

   d3.rebind(exports, dispatch, 'on');
   return exports;
};